import * as React from 'react';
const h = React.createElement;
import { Spin } from './Spin';
import { Empty } from './Empty';

export interface ListProps<T = unknown> {
  dataSource?: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  loading?: boolean;
  locale?: { emptyText?: React.ReactNode };
  className?: string;
}

function List<T>(props: ListProps<T>): React.ReactElement {
  const { dataSource = [], renderItem, loading, locale, className = '' } = props;
  return h(
    'div',
    { className },
    loading
      ? h(Spin)
      : dataSource.length === 0
        ? h(Empty, { description: locale?.emptyText })
        : dataSource.map((item, index) => renderItem(item, index)),
  ) as React.ReactElement;
}

export { List };
